import D2C_Service from '../Service'

class D2C_ServiceOther extends D2C_Service {
  static objectType = 'serviceRole'
  static groupTitle = 'Other'
  static roleName = 'other'
  static roleTitle = 'Other'
}

export default D2C_ServiceOther
